import { useState } from 'react';
import { getActiveSubsidiaries, getSubsidiaryByCity } from '@shared/services/api/subsidiaryService';

export const useSubsidiariesByCity = () => {
  const [state, setState] = useState([]);

  const getSubsidiaries = async (city) => {
    const response = await getSubsidiaryByCity(city);
    const { data: subsidiaries } = response;
    setState(subsidiaries);
  };

  const getAllSubsidiaries = async () => {
    const response = await getActiveSubsidiaries();
    const { data: subsidiaries } = response;
    setState(subsidiaries);
  };

  return {
    state,
    setState,
    getSubsidiaries,
    getAllSubsidiaries,
  };
};
